module.exports = __webpack_public_path__ + "media/application/images/icons/book-a02e90af316c5a650bcf2592a7770362.svg";